/* Combined-listing colorway swatches: clicking a swatch swaps the product
   card in place (image, title, price, links, quick-add target) instead of
   navigating. Swatches without swap data fall back to plain links, as does
   everything when JS is unavailable.
   Covers product-grid-item and collection-grid-toggle cards; the listener is
   delegated so cards added by infinite scroll / filtering work too. */
(function() {
  var SWATCH = '.combined-swatch';
  var CONTAINER = '.grid-product__combined-swatches';
  var CARD = '.grid-product, .collection-grid-toggle__item';

  document.addEventListener('click', function(evt) {
    var swatch = evt.target.closest(SWATCH);
    if (!swatch) return;

    var data = swatch.dataset;
    if (!data.productTitle) return; // no swap data: behave as a normal link

    var card = swatch.closest(CARD);
    if (!card) return;

    evt.preventDefault();
    if (swatch.classList.contains('combined-swatch--active')) return;

    var url = swatch.getAttribute('href');

    // Point the card's product links at the selected colorway
    card.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
      if (link.closest(CONTAINER)) return;
      link.setAttribute('href', url);
    });

    var title = card.querySelector('.grid-product__title, .collection-grid-toggle__product-title');
    if (title) title.textContent = data.productTitle;

    // Images: two-slide swipe when the product has a second image, else one img
    var imageScope = card.querySelector('.grid-product__image-mask, .collection-grid-toggle__image-wrapper') || card;
    var slides = imageScope.querySelectorAll('.grid-swipe__slide img');
    if (slides.length) {
      setImage(slides[0], data.productImage);
      setImage(slides[1], data.productImage2 || data.productImage);
    } else {
      setImage(imageScope.querySelector('img'), data.productImage);
    }

    if (data.productPrice) {
      var price = card.querySelector(
        '.grid-product__price-overlay-current, .collection-grid-toggle__price-overlay-current, .collection-grid-toggle__price-current'
      );
      if (price) price.textContent = data.productPrice;
    }

    // Update card identity so quick add targets the selected colorway
    if (data.productHandle) card.setAttribute('data-product-handle', data.productHandle);
    if (data.productId) card.setAttribute('data-product-id', data.productId);
    var variantOptions = card.querySelectorAll('.variant-option');
    if (data.variantId && variantOptions.length === 1) {
      variantOptions[0].setAttribute('data-variant-id', data.variantId);
    }

    var group = swatch.closest(CONTAINER);
    if (group) {
      group.querySelectorAll(SWATCH).forEach(function(el) {
        el.classList.remove('combined-swatch--active');
        el.removeAttribute('aria-current');
        el.setAttribute('data-is-current', 'false');
      });
    }
    swatch.classList.add('combined-swatch--active');
    swatch.setAttribute('aria-current', 'true');
    swatch.setAttribute('data-is-current', 'true');
  });

  function setImage(img, src) {
    if (!img || !src) return;
    img.src = src;
    if (img.hasAttribute('srcset')) img.setAttribute('srcset', src);
  }
})();
